import { api, apiList, uploadFormData } from '../../api/client';
import type { FileAssetDto } from '../carrierCabinet/api';

export interface SupportMessageDto {
  id: number;
  ticket: number;
  sender: number | null;
  sender_name: string;
  sender_role: 'user' | 'support' | 'system';
  body: string;
  attachment: number | null;
  attachment_file: FileAssetDto | null;
  is_internal: boolean;
  created_at: string;
}

export interface SupportTicketDto {
  id: number;
  public_code: string;
  owner: number;
  owner_role: 'customer' | 'carrier';
  category: string;
  category_label: string;
  subject: string;
  status: string;
  status_label: string;
  priority: string;
  priority_label: string;
  assigned_to: number | null;
  assigned_to_name: string;
  related_request: number | null;
  related_deal: number | null;
  last_message: SupportMessageDto | null;
  unread_count: number;
  created_at: string;
  updated_at: string;
}

export interface FaqEntryDto {
  id: number;
  audience: 'customer' | 'carrier';
  question: string;
  answer: string;
  sort_order: number;
}

function uploadAttachment(file: File, onProgress?: (percent: number) => void) {
  const body = new FormData();
  body.append('file', file);
  body.append('purpose', 'support_attachment');
  body.append('visibility', 'private');
  return uploadFormData<FileAssetDto>('/api/media/', body, onProgress);
}

export const supportApi = {
  faq: (audience: 'customer' | 'carrier', language: 'ru' | 'en') => apiList<FaqEntryDto>(
    `/api/support/faq/?audience=${audience}&language=${language}`,
  ),
  tickets: () => apiList<SupportTicketDto>('/api/support/tickets/'),
  createTicket: (payload: {
    category: string;
    subject: string;
    initial_message: string;
    related_request?: number | null;
    related_deal?: number | null;
    attachment?: number | null;
  }) => api<SupportTicketDto>('/api/support/tickets/', { method: 'POST', body: payload }),
  messages: (ticketId: number) => apiList<SupportMessageDto>(`/api/support/tickets/${ticketId}/messages/`),
  sendMessage: (ticketId: number, body: string, attachment?: number | null) => api<SupportMessageDto>(
    `/api/support/tickets/${ticketId}/messages/`,
    { method: 'POST', body: { body, attachment: attachment ?? null } },
  ),
  setStatus: (ticketId: number, action: 'close' | 'reopen') => api<SupportTicketDto>(
    `/api/support/tickets/${ticketId}/status/`, { method: 'POST', body: { action } },
  ),
  uploadAttachment,
};
